/**
 * Definição de perfis/roles do sistema EducaPaço
 */

export const ROLES = {
  ADMIN: "ADMIN",
  ADMINISTRATIVO: "ADMINISTRATIVO",
  GESTOR: "GESTOR",
  SECRETARIA: "SECRETARIA",
  COORDENADOR: "COORDENADOR",
  MONITOR: "MONITOR",
  EXECUTIVO: "EXECUTIVO",
  TECNICO_GERAL: "TECNICO_GERAL",
  TECNICO: "TECNICO",
};

/**
 * Permissões por role
 * Cada role tem acesso a diferentes funcionalidades
 */
export const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: {
    // Acesso total
    canManageUsers: true,
    canManageAlunos: true,
    canManageNucleos: true,
    canManageTurmas: true,
    canManageMatriculas: true,
    canRegisterFrequencia: true,
    canManageAvaliacoes: true,
    canViewDashboards: true,
    canGenerateReports: true,
    canManageCatalogos: true,
  },
  [ROLES.TECNICO_GERAL]: {
    // Acesso total (Cópia de ADMIN)
    canManageUsers: true,
    canManageAlunos: true,
    canManageNucleos: true,
    canManageTurmas: true,
    canManageMatriculas: true,
    canRegisterFrequencia: true,
    canManageAvaliacoes: true,
    canViewDashboards: true,
    canGenerateReports: true,
    canManageCatalogos: true,
  },
  [ROLES.TECNICO]: {
    // Técnico: acesso total (multitenant)
    canManageUsers: true,
    canManageAlunos: true,
    canManageNucleos: true,
    canManageTurmas: true,
    canManageMatriculas: true,
    canRegisterFrequencia: true,
    canManageAvaliacoes: true,
    canViewDashboards: true,
    canGenerateReports: true,
    canManageCatalogos: true,
  },
  [ROLES.ADMINISTRATIVO]: {
    canManageUsers: true,
    canManageAlunos: true,
    canManageNucleos: true,
    canManageTurmas: true,
    canManageMatriculas: true,
    canRegisterFrequencia: true,
    canManageAvaliacoes: true,
    canViewDashboards: true,
    canGenerateReports: true,
    canManageCatalogos: true,
  },
  [ROLES.GESTOR]: {
    canManageUsers: false,
    canManageAlunos: true,
    canManageNucleos: true,
    canManageTurmas: true,
    canManageMatriculas: true,
    canRegisterFrequencia: true,
    canManageAvaliacoes: true,
    canViewDashboards: true,
    canGenerateReports: true,
    canManageCatalogos: true,
  },
  [ROLES.COORDENADOR]: {
    canManageUsers: false,
    canManageAlunos: true,
    canManageNucleos: false,
    canManageTurmas: true,
    canManageMatriculas: true,
    canRegisterFrequencia: true,
    canManageAvaliacoes: true,
    canViewDashboards: true,
    canGenerateReports: true,
    canManageCatalogos: false,
  },
  [ROLES.MONITOR]: {
    canManageUsers: false,
    canManageAlunos: false,
    canManageNucleos: false,
    canManageTurmas: false,
    canManageMatriculas: false,
    canRegisterFrequencia: true,
    canManageAvaliacoes: false, // Verificação dinâmica baseada em vinculação a atividades pedagógicas
    canViewDashboards: false,
    canGenerateReports: false,
    canManageCatalogos: false,
  },
  [ROLES.EXECUTIVO]: {
    canManageUsers: false,
    canManageAlunos: false,
    canManageNucleos: false,
    canManageTurmas: false,
    canManageMatriculas: false,
    canRegisterFrequencia: false,
    canManageAvaliacoes: false,
    canViewDashboards: true,
    canGenerateReports: true,
    canManageCatalogos: false,
  },
};

// SECRETARIA começa com as regras do GESTOR (Alembic 0009 no backend).
ROLE_PERMISSIONS[ROLES.SECRETARIA] = { ...ROLE_PERMISSIONS[ROLES.GESTOR] };

export const PAPEIS_GESTOR = [ROLES.GESTOR, ROLES.SECRETARIA];

export const isGestor = role => PAPEIS_GESTOR.includes(role);

/**
 * Labels amigáveis para os roles
 */
export const ROLE_LABELS = {
  [ROLES.ADMIN]: "Administrador",
  [ROLES.ADMINISTRATIVO]: "Administrativo",
  [ROLES.GESTOR]: "Gestor",
  [ROLES.SECRETARIA]: "Secretaria",
  [ROLES.COORDENADOR]: "Coordenador",
  [ROLES.MONITOR]: "Monitor",
  [ROLES.EXECUTIVO]: "Executivo",
  [ROLES.TECNICO_GERAL]: "Técnico Geral",
  [ROLES.TECNICO]: "Técnico",
};

/**
 * Verifica se um role tem uma permissão específica
 */
export const hasPermission = (role, permission) => {
  const permissions = ROLE_PERMISSIONS[role];
  if (!permissions) return false;
  return permissions[permission] === true;
};

/**
 * Verifica se um role tem acesso a uma funcionalidade
 */
export const canAccess = (role, ...permissions) => {
  return permissions.every(permission => hasPermission(role, permission));
};

const roles = {
  ROLES,
  ROLE_PERMISSIONS,
  ROLE_LABELS,
  hasPermission,
  canAccess,
  isGestor,
};

export default roles;
